import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ArrowLeft, Search, BookOpen, MessageCircle, FileText, Download } from "lucide-react";

export default function HelpCenterPage() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50 text-gray-900 font-sans">
      <header className="border-b bg-white sticky top-0 z-40 shadow-sm">
        <div className="max-w-5xl mx-auto px-4 py-3 flex flex-col md:flex-row justify-between items-center gap-4">
          <Link to="/">
            <img src="/marketing/logo_official.png" className="h-28 object-contain" alt="OdontoAssist AI Logo" />
          </Link>
          <div className="flex items-center gap-3 flex-wrap justify-center">
            <Link
              to="/instalar"
              className="bg-white border border-indigo-200 hover:bg-indigo-50 text-indigo-700 px-6 py-3 rounded-2xl font-black tracking-wide flex items-center gap-2 transition-all shadow-sm"
            >
              <Download size={20} />
              Instalar app
            </Link>

            <Link
              to="/"
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-2xl font-black tracking-wide flex items-center gap-2 transition-all shadow-lg hover:-translate-y-1"
            >
              <ArrowLeft size={20} />
              Voltar {user ? "para o Aplicativo" : "ao Início"}
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-16 space-y-12">
        <div className="text-center space-y-6">
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight">Como podemos ajudar?</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Encontre respostas rápidas para suas dúvidas ou entre em contato com nossa equipe de suporte.
          </p>

          <div className="flex justify-center">
            <Link
              to="/instalar"
              className="inline-flex items-center gap-2 rounded-2xl bg-indigo-600 text-white px-6 py-3 font-bold hover:bg-indigo-700 transition-all shadow-lg"
            >
              <Download size={18} />
              Ver instruções para instalar o app no celular
            </Link>
          </div>

          <div className="max-w-xl mx-auto relative mt-8">
            <input
              type="text"
              placeholder="Descreva seu problema ou dúvida..."
              className="w-full pl-12 pr-4 py-4 rounded-full border-2 border-indigo-100 focus:border-indigo-600 focus:outline-none shadow-sm text-lg transition-colors"
            />
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={24} />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 pt-8">
          <Link to="/ajuda/primeiros-passos" className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow cursor-pointer group block">
            <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <BookOpen size={24} />
            </div>
            <h3 className="text-xl font-bold mb-3">Primeiros Passos</h3>
            <p className="text-gray-600 leading-relaxed">Aprenda a configurar sua conta, importar pacientes e personalizar documentos.</p>
          </Link>

          <Link to="/ajuda/tutoriais" className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow cursor-pointer group block">
            <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <FileText size={24} />
            </div>
            <h3 className="text-xl font-bold mb-3">Tutoriais e Guias</h3>
            <p className="text-gray-600 leading-relaxed">Guias detalhados sobre prontuários, odontogramas e gestão financeira.</p>
          </Link>

          <Link to="/contato" className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow cursor-pointer group block">
            <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <MessageCircle size={24} />
            </div>
            <h3 className="text-xl font-bold mb-3">Dúvidas Frequentes</h3>
            <p className="text-gray-600 leading-relaxed">Fale com nossa equipe, e veja as respostas para as perguntas mais comuns.</p>
          </Link>
        </div>
      </main>
    </div>
  );
}